// extracted by mini-css-extract-plugin
module.exports = {"names":"DeliveryPerformanceDetailHeader_names__3TWoR","name":"DeliveryPerformanceDetailHeader_name__3e96a"};